/* eslint-disable */
<template>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="lbl-title">Informações do Provedor</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="info-group">
          <strong>Nome:</strong>
          <p>{{ info.name }}</p>
        </div>
        <div class="info-group">
          <strong>Número:</strong>
          <p>{{ info.formattedNumber }}</p>
        </div>
        <div class="info-group">
          <strong>Provedor:</strong>
          <p>{{ info.type === 'whats_meta' ? 'Meta' : 'Whatsapp' }}</p>
        </div>
        <div v-if="info.type === 'whats_meta'">
          <div class="info-group">
            <strong>Token da META:</strong>
            <p>{{ info.metaToken }}</p>
          </div>
          <div class="info-group">
            <strong>Número META:</strong>
            <p>{{ info.metaNumber }}</p>
          </div>
        </div>
        <div class="info-group">
          <strong>Número da API:</strong>
          <p>{{ info.apinumber }}</p>
        </div>
        <div class="info-group">
          <label for="ToogleSwitchActive">Status do número</label>
          <ToogleSwitch id="ToogleSwitchActive" v-model="info.active" />
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-third btn-sm" @click="save" v-b-tooltip.hover :title="'Salvar'">
          <i class="fa "></i><span class="d-md-down-none">Salvar</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import defaultbutton from '@/components/UI/button/defaultButton.vue'
import NumRepository from '@/shared/http/repositories/access/cadastroNum.js'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'

export default {
  name: 'ProvedorInformation',
  data () {
    return {
      info: null,
      active: null
    }
  },
  props: {
    infoProvider: {
      type: Object,
      required: true
    }
  },
  created () {
    this.printInfo()
  },
  components: {
    defaultbutton,
    ToogleSwitch
  },
  watch: {
    infoProvider: {
      handler (newVal) {
        this.info = newVal
        this.active = newVal.active
      },
      immediate: true
    }
  },
  methods: {
    save () {
      const requestConfig = {
        id: this.info.id
      }
      try {
        NumRepository.update(requestConfig)
        this.$emit('clicked-close')
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    closeModal () {
      this.info.active = this.active
      this.$emit('clicked-close')
    },
    printInfo () {
      console.log('oi')
    }
  }
}

</script>

<style scoped>
.modal-dialog {
  min-height: 35vh;
  overflow-y: auto;
  min-width:  40vh;
}

.info-group {
  margin-bottom: 15px;
}

.info-group strong {
  display: block;
  font-weight: bold;
}

.info-group p {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/provedores/information/ProvedorInformation.vue